
const renderPhoneLink = (number, formattedNumber, phoneLabel) => {
  if (number.match(/^\d*$/) && number.length !== 0 && formattedNumber.length !== 0) {
      return `
            <div class="phone">
                 <span>${phoneLabel}</span>
                <a class="tel-link" href="tel:${number}">${formattedNumber}</a>
                <span class="non-clickable-tel-link">${formattedNumber}</span>
            </div>
        `;
  } else if (number.length !== 0) {
    return `<div>${number}</div>`;
  }
  return ``;
};

const renderEmailLink = (email, emailLabel) => {
  if (email !== null && email !== undefined && email !== 'null' && email.length !== 0) {
      return `
            <div class="email">
                <span>${emailLabel}</span>
                <a href="mailto:${email}">${email}</a>
            </div>
        `;
  }
  return ``;
};

export const createEmployeeCardRendering = (employee, texts) => {
  return `
    <article class="card contact-card card-single">
      <div class="card-content">
        <div class="card-image">
            <picture>
                <source media="(min-width: 1010px)"
                    srcSet="${employee.imgSrc310} 1x, 
                            ${employee.imgSrc620} 2x" />

                <source media="(min-width: 680px) and (max-width: 1009px)"
                    srcSet="${employee.imgSrc320} 1x, 
                            ${employee.imgSrc640} 2x" />

                <source media="(max-width: 679px)"
                    srcSet="${employee.imgSrc659} 1x, 
                            ${employee.imgSrc1318} 2x" />

                <img srcSet="${employee.imgSrc310} 310w,
                            ${employee.imgSrc320} 320w,
                            ${employee.imgSrc659} 659w"
                    sizes="(max-width: 679px) 659px,
                           (min-width: 680px) and (max-width: 1009px) 320px,
                           (max-width: 10101px) 310px"
                    src="${employee.imgSrc659} 659w" 
                    type="image/*"
                    alt="${employee.imgAlt}" />
            </picture>
        </div>
        <div class="card-body">
            <div class="contact vcard">
                <strong class="fn">${employee.name}</strong>
                <div>${employee.title}</div>
                ${renderPhoneLink(employee.phone, employee.phoneFormatted, texts.phoneLabel)}
                ${renderEmailLink(employee.email, texts.emailLabel)}
            </div>
        </div>
      </div>
    </article>
    `;
};
